export const FONT = "'Barlow Condensed', 'Arial Narrow', Arial, sans-serif";

let ctx = null;

// Measure at 100px and scale: canvas metrics at tiny sizes are quantized.
export function measure(text, size, weight = 600) {
  if (!ctx) ctx = document.createElement('canvas').getContext('2d');
  ctx.font = `${weight} 100px ${FONT}`;
  return (ctx.measureText(text || '').width * size) / 100;
}

// Fit text into maxW: shrink down to minScale first, then ellipsize.
export function fitText(text, maxW, size, weight = 600, minScale = 0.8) {
  const t = String(text ?? '');
  if (!t || maxW <= 0) return { text: '', size };
  const w = measure(t, size, weight);
  if (w <= maxW) return { text: t, size };
  if (w * minScale <= maxW) return { text: t, size: (size * maxW) / w };
  const s = size * minScale;
  let lo = 0;
  let hi = t.length;
  while (lo < hi) {
    const mid = Math.ceil((lo + hi) / 2);
    if (measure(`${t.slice(0, mid).trimEnd()}…`, s, weight) <= maxW) lo = mid;
    else hi = mid - 1;
  }
  return { text: lo ? `${t.slice(0, lo).trimEnd()}…` : '', size: s };
}

// Card width as a multiple of font size, sized to the longest real team name.
export function nameRatio(names, hasLogos) {
  const widest = names.reduce((mx, n) => Math.max(mx, measure(n, 1, 600)), 0);
  return Math.min(14, Math.max(7.5, widest * 0.82 + 3.8 + (hasLogos ? 1.3 : 0)));
}

// One team-name size for the whole bracket (90th percentile fit) so rows
// stay typographically consistent; rare outliers shrink individually.
export function uniformNameSize(names, M, hasLogos) {
  const maxW = M.cardW - M.fs * (3.3 + (hasLogos ? 1.45 : 0));
  const fits = names.filter(Boolean).map((n) => maxW / Math.max(1e-6, measure(n, 1, 700))).sort((a, b) => a - b);
  if (!fits.length) return M.fs;
  const p = fits[Math.floor(fits.length * 0.1)];
  return Math.min(M.fs, Math.max(M.fs * 0.72, p));
}
